<!-- ItemArvore.vue -->
<template>
    <div>
        <b-row
            class="w-100 text-left d-flex justify-content-between align-items-center ml-1 p-1 border-bottom bg-light no-break"
        >
            <b-col
                class="col-1"
            >
                <b-button
                    v-if="item.itens && item.itens.length > 0"
                    v-b-toggle="'collapse-' + item.item"
                    variant="link"
                    :class="{ 'bg-light': item.itens && item.itens.length > 0 }"
                >
                    <i :class="collapsed ? 'fa fa-chevron-right' : 'fa fa-chevron-down'"></i>
                </b-button>
            </b-col>
            <b-col>
                <span class="text-dark font-weight-bold">
                    <i :class="item.itens && item.itens.length > 0 ? 'fa fa-folder-o' : 'fa fa-file-o'" class="mr-2"></i>
                    {{ item.item }} - {{ item.descricao }}
                </span>
            </b-col>
            <b-col cols="2" class="text-right">
                <div class="font-weight-bold">Total</div>
                {{ item.total | moeda(2) }}
            </b-col>
            <b-col cols="1" class="text-right">
                <div class="font-weight-bold">Peso</div>
                {{ item.peso }}%
            </b-col>
        </b-row>


        <b-collapse
            :id="'collapse-' + item.item"
            visible
            class="no-break"
            @shown="collapsed = false"
            @hidden="collapsed = true"
        >
            <!-- Detalhes do item se não tiver subitens -->
            <div
                v-if="!item.itens || item.itens.length === 0"
                class="pl-3 p-1 border-bottom text-muted "
            >
                <b-row>
                    <b-col cols="2">
                        <div class="font-weight-bold">Código</div>
                        {{ item.codigo }}
                    </b-col>
                    <b-col cols="1">
                        <div class="font-weight-bold">Tipo</div>
                        {{ item.tipoDescricao }}
                    </b-col>
                    <b-col cols="1">
                        <div class="font-weight-bold">Unidade</div>
                        {{ item.unidadeMedida }}
                    </b-col>
                    <b-col cols="1" class="text-right">
                        <div class="font-weight-bold">Qtde</div>
                        {{ item.quantidade | currency2 }}
                    </b-col>
                    <b-col cols="2" class="text-right">
                        <div class="font-weight-bold"> R$ Unitário</div>
                        <money
                            v-if="exibirForm"
                            :disabled="!habilitarForm"
                            :class="['form-control', 'text-right', { 'campo-zerado': habilitarForm && (!item.valorUnitario || item.valorUnitario <= 0) }]"
                            v-model="item.valorUnitario"
                            v-bind="configuracaoDecimal"
                            :precision="2"
                            @blur.native="atualizarItem(item)"
                        />
                        <span v-else class="d-block">
                            {{ item.valorUnitario | moeda(2) }}
                        </span>

                    </b-col>
                    <b-col v-if="!semBDI" cols="2" class="text-right">
                        <div class="font-weight-bold">R$ Unitário Com BDI</div>
                        {{ item.valorUnitarioComBDI | moeda(2) }}
                    </b-col>
                    <b-col cols="2" class="text-right">
                        <div class="font-weight-bold">Total</div>
                        {{ item.total | moeda(2) }}
                    </b-col>
                    <b-col cols="1" class="text-right">
                        <div class="font-weight-bold">Peso</div>
                        {{ item.peso }}%
                    </b-col>
                </b-row>
            </div>

            <!-- Subitens recursivos -->
            <div v-else>
                <arvore-itens
                    v-for="(subitem, idx) in item.itens"
                    :key="idx"
                    :exibir-form="exibirForm"
                    :habilitar-form="habilitarForm"
                    :item="subitem"
                    :bdiGeral="bdiGeral"
                    :bdiDiferenciado="bdiDiferenciado"
                    :semBDI="semBDI"
                    @item-alterado="$emit('item-alterado', $event)"
                    @item-atualizado="$emit('item-atualizado', $event)"
                />
            </div>
        </b-collapse>
    </div>
</template>

<script>
export default {
    name: 'ArvoreItens',
    props: {
        item: {
            type: Object,
            required: true
        },
        bdiGeral: {
            type: Number,
            required: true,
            default: 0
        },
        bdiDiferenciado: {
            type: Number,
            required: true,
            default: 0
        },
        exibirForm: {
            type: Boolean,
            default: false
        },
        habilitarForm: {
            type: Boolean,
            default: false
        },
        semBDI: {
            type: Boolean,
            default: false
        },
    },

    data() {
        return {
            collapsed: false
        }
    },

    computed: {
        configuracaoDecimal() {
            return {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                precision: 2,
                masked: false
            }
        }
    },

    methods: {
        calcularValorUnitarioComBDI(itemPropostaPreco) {
            const TIPO_SERVICO = 1
            const TIPO_MATERIAL = 2

            const valorUnitario = Number(itemPropostaPreco.valorUnitario) || 0
            const bdiGeral = Number(this.bdiGeral) || 0
            const bdiDiferenciado = Number(this.bdiDiferenciado) || 0
            const quantidade = Number(itemPropostaPreco.quantidade) || 0

            if (this.semBDI) {
                itemPropostaPreco.valorUnitarioComBDI = valorUnitario
            } else if (itemPropostaPreco.tipo && itemPropostaPreco.tipo == TIPO_MATERIAL) {
                itemPropostaPreco.valorUnitarioComBDI = valorUnitario * (1 + bdiDiferenciado / 100)
            } else if (itemPropostaPreco.tipo && itemPropostaPreco.tipo == TIPO_SERVICO) {
                itemPropostaPreco.valorUnitarioComBDI = valorUnitario * (1 + bdiGeral / 100)
            }

            itemPropostaPreco.total = itemPropostaPreco.valorUnitarioComBDI * quantidade
        },

        atualizarItem(itemPropostaPreco) {
            this.calcularValorUnitarioComBDI(itemPropostaPreco);
            this.$emit('item-atualizado', itemPropostaPreco);
        }
    },

    watch: {
        'item.valorUnitario'(newValue) {
            if (this.item && this.item.tipo) {
                this.calcularValorUnitarioComBDI(this.item)
                this.$emit('item-alterado', this.item)
            }
        },

        bdiGeral(newValue) {
            if (this.item && this.item.tipo) {
                this.calcularValorUnitarioComBDI(this.item)
            }
        },
        bdiDiferenciado(newValue) {
            if (this.item && this.item.tipo) {
                this.calcularValorUnitarioComBDI(this.item)
            }
        }
    },
}
</script>

<style scoped>
.no-break {
    page-break-inside: avoid;
    break-inside: avoid;
}

.pagebreak-before {
    page-break-before: always;
    break-before: always;
}

.pagebreak-after {
    page-break-after: always;
    break-after: always;
}

.campo-zerado {
    border-color: #dc3545 !important;
    border-width: 2px !important;
}

.campo-zerado:focus {
    border-color: #dc3545 !important;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
}


</style>
